

<script>
    import { Bar } from "vue-chartjs"
    export default {
        extends: Bar,
        props:{
            label:{
                Type:String
            },
            chartData:{
                type:Array
            },
            options:{
                type:Object
            },
            chartColors: {
                type: Object
            }
        },
        
        mounted(){
            const label = this.chartData.map(d => d.label)
            const data = this.chartData.map(d => d.data)

            this.renderChart(
            {
                labels: label,//local
                datasets:[{
                    label: this.label, //global
                    data: data, //local
                    backgroundColor: 'red',
                }]
                
            }, 
            this.options
            )
            
        },
    }
</script>

<style lang="scss" scoped>

</style>